var util = angular.module('gymsystem.util');
util.controller('ApnSettingsCtrl', ['$rootScope', '$scope', 'server', 'Setting', '$controller', 'alertProvider', function ($rootScope, $scope, server, Setting, $controller, alertProvider) {
        $controller('ChangeCtrl', { $scope: $scope });
        $scope.item = {};
        $scope.loadingStatus = {};
        $scope.kommuner = [];
        $scope.title = null;
        var serviceOptions = [
            { id: 'apn', name: 'APN' },
            { id: 'rbok', name: 'RBok' }
        ];
        var sendOptions = [
            { id: 1, name: '1. Varje lag har sin aktivitet per match' },
            { id: 2, name: '2. Varje match blir en aktivitet , alla lag på den matchen hamnar under samma aktivitet' },
            { id: 3, name: '3. En aktivitet per arena, alla matcher/aktiviteter som varit på samma arena/resurs vid samma tid och samma aktivitetstyp skickas in som en gemensam aktivitet' },
            { id: 4, name: '4. En aktivitet per tid, alla matcher/aktiviteter som varit på samma vid samma tid och samma aktivitetstyp skickas in som en gemensam aktivitet' }
        ];
        $scope.fields = [
            { name: 'service', title: 'Grant service', type: 'select', required: true, options: function () { return serviceOptions; }, useId: true },
            { name: 'foerenings', title: 'Association ID', type: 'label' },
            { name: 'kommun_code', title: 'Municipality', required: true, type: 'select', useId: true, options: function () { return $scope.kommuner; } },
            { name: 'autosend', title: 'Auto send', required: false, type: 'checkbox' },
            {
                name: 'sendmode',
                title: 'Hur ska aktiviteterna rapporteras? ',
                required: false,
                type: 'select',
                useId: true,
                options: function () { return sendOptions; }
            }
        ];
        server.get('/api/apn/get_kommuner').then(function (data) {
            data.forEach(function (d) {
                d.name += ', ' + d.code;
                d.id = d.code;
            });
            $scope.kommuner = data;
            if ($scope.item.kommun_code) {
                var kommunField = _.findWhere($scope.fields, { name: 'kommun_code' });
                kommunField.value = _.findWhere($scope.kommuner, { id: $scope.item.kommun_code });
            }
        });
        Setting.get('apn').then(function (settings) {
            $scope.item = settings;
            $scope.setValues(settings);
            _.findWhere($scope.fields, { name: 'foerenings' }).value = settings.foerenings;
            if (!settings.service) {
                _.findWhere($scope.fields, { name: 'service' }).value = serviceOptions[0];
            }
        });
        $scope.getButtonText = function () { return 'Save changes'; };
        $scope.submit = function () {
            $scope.loadingStatus.loading = true;
            var settings = $scope.getSubmitItem();
            Setting.set('apn', settings).then(function () {
                $scope.item = settings;
                alertProvider.show('success', 'Settings saved');
                $scope.loadingStatus.loading = false;
            }, function () {
                alertProvider.show('error', 'Failed to save settings');
                $scope.loadingStatus.loading = false;
            });
        };
    }]);
